export default "https://cdn.cloudgame.qcloud.com/static/sg/prod/dist/img/dialog_cover_id.095fe2b95fad270052229a2d2ce7ea17.png";